import Icon, { IconVariant } from "@galaxy-io/dls/icons/Icon";
import { TextVariant } from "@galaxy-io/dls/text/Text";
import { type ReviewState, reviewLabels, reviewStates } from "@gtm/contracts/core/review";
import {
  BookmarkSimpleIcon,
  CheckCircleIcon,
  CircleDashedIcon,
  CircleIcon,
  EnvelopeSimpleIcon,
  ProhibitIcon,
} from "@phosphor-icons/react";

export const reviewIcons = {
  unprocessed: CircleDashedIcon,
  acknowledged: CircleIcon,
  drafted: EnvelopeSimpleIcon,
  saved: BookmarkSimpleIcon,
  processed: CheckCircleIcon,
  ignored: ProhibitIcon,
} satisfies Record<ReviewState, typeof CircleIcon>;

export function ReviewStateIcon({ state, size = 14 }: { state: ReviewState; size?: number }) {
  return (
    <Icon
      component={reviewIcons[state]}
      size={size}
      variant={state === "processed" ? IconVariant.SUCCESS : IconVariant.SECONDARY}
    />
  );
}

export const reviewStatusOptions = reviewStates.map((state) => ({
  value: state,
  label: reviewLabels[state],
  variant: state === "processed" ? TextVariant.SUCCESS : TextVariant.SECONDARY,
  icon: <ReviewStateIcon state={state} />,
}));
